import React, { Component } from 'react';
import { connect } from 'react-redux';

import axios from "axios";
import moment from "moment";
import { withRouter } from 'react-router-dom';
import { debounce } from "lodash";

import Select from 'react-select';
import { constants } from '../../Helpers/Constants';

import { AddPhoto, Camera, CameraRetake, CheckIcon} from '../Common/Buttons/Icons';
import { LoadingIcon } from '../Common/Loading_Icon';
import { Trans } from 'react-i18next';

class IDVerification extends Component {
    constructor(props) {
        super(props);

        this.startCamera = this.startCamera.bind(this);
        this.captureCamera = this.captureCamera.bind(this);
        this.confirmCamera = this.confirmCamera.bind(this);
        this.updateProvince = this.updateProvince.bind(this);
        this.submitValidation = debounce(this.submitValidation.bind(this), 500);
        this.handleCameraError = this.handleCameraError.bind(this);
        this.generateCamIconAction = this.generateCamIconAction.bind(this);

        this.state = {
            province_selected: false,
            video: {
                front: false,
                back: false,
            },
            capture: {
                front: false,
                back: false,
            },
            confirm: {
                front: false,
                back: false,
            },
            error: {
                province: false,
                front: false,
                back: false
            },
            camera_support: false,
            selectedProvince: null,
            submiting_request: false
        };
    }

    componentDidMount() {
        document.title = "Driver\'s License Validation - FleetXPress"

        if(!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia))
        {
            var self = this;
            
            self.setState({
                camera_support: true
            });
        }
    }

    submitValidation() {
        var self = this;

        if(!this.state.camera_support || !this.state.province_selected || !this.state.confirm.front || !this.state.confirm.back)
        {
            var error = self.state.error;

            if(!this.state.camera_support)
            {
                showStatusMsg("Your browser or device is not supported for this feature. <br /><br /> You can skip this step for now and complete the process later in your User Profile using an alternate browser or device.")
            }
            else if(!this.state.province_selected)
            {
                error["province"] = true;

                self.setState({
                    error: error
                });

                showStatusMsg("Please select your province");
            }
            else if(!this.state.confirm.front)
            {
                error["front"] = true;

                self.setState({
                    error: error
                });

                showStatusMsg("Please upload and confirm a picture of the front side of your driving license");
            }
            else if(!this.state.confirm.back)
            {
                error["back"] = true;

                self.setState({
                    error: error
                });

                showStatusMsg("Please upload and confirm a picture of the back side of your driving license");
            }
            else
            {
                showStatusMsg("Please select your province and upload front and back of your Drivers License");
            }

            return false;
        }

        let formData = new FormData();
        formData.append('province', this.state.selectedProvince.value);
        formData.append('validation-front', ($('.validation-photo-container.front')[0].src));
        formData.append('validation-back', ($('.validation-photo-container.back')[0].src));

        self.setState({
            submiting_request: false
        });

        axios.post("/ajax/identification", formData)
        .then(function(response) {
            showStatusMsg(response?.data.message, 'success');
            self.props.history.push('/mobilevalidation')
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }

            self.setState({
                submiting_request: false
            });
        })
    }

    updateProvince(option) {
        var self = this;
        var error = self.state.error;

        error["province"] = false;

        self.setState({
            province_selected: true,
            selectedProvince: option,
            error: error
        });
    }

    startCamera(side) {
        var self = this;
        var video = self.state.video;
        var error = self.state.error;
        var capture = self.state.capture;
        var confirm = self.state.confirm;

        if((side == "front" || side == "back") && !self.state.province_selected)
        {
            error["province"] = true;

            self.setState({
                error: error
            });

            showStatusMsg("Please select your province");
            return false;
        } 
        else if(side == "back" && !this.state.confirm.front)
        {
            error["front"] = true;

            self.setState({
                error: error
            });

            showStatusMsg("Please upload and confirm a picture of the front side of your driving license");
            return false;
        }

        const constraints = {
            video: {
                width: {
                    min: 320,
                    max: 1280
                },
                height: {
                    min: 240,
                    max: 720
                },
                facingMode: "environment",
            },
        };
        const video_div = $('.validation-video-container.' + side)[0];
        video_div.setAttribute('autoplay', '');
        video_div.setAttribute('muted', '');
        video_div.setAttribute('playsinline', '');
        navigator.mediaDevices.getUserMedia(constraints).then((stream) => {video_div.srcObject = stream}).catch((error) => this.handleCameraError(error, side));

        video[side] = true;
        capture[side] = false;
        confirm[side] = false;

        self.setState({
            video: video,
            capture: capture,
            confirm: confirm
        });
    }

    captureCamera(side) {
        var self = this;
        var capture = self.state.capture;

        const canvas = document.createElement('canvas');
        const video = $('.validation-video-container.' + side)[0];
        const img = $('.validation-photo-container.' + side)[0];

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight, 0, 0, video.videoWidth, video.videoHeight);

        img.src = canvas.toDataURL('image/png');

        capture[side] = true;

        self.setState({
            capture: capture
        });
    }

    confirmCamera(side) {
        var self = this;
        var confirm = self.state.confirm;

        confirm[side] = true;

        self.setState({
            confirm: confirm
        });
    }

    handleCameraError(error, side) {
        var self = this;
        var video = self.state.video;

        if(error.name == "NotAllowedError")
        {
            showStatusMsg("You have denied camera access that is necessary for this feature. Please refresh your browser or grant access to your camera.")
        }
        else
        {
            showStatusMsg("Your browser or device is not supported for this feature. <br /><br /> You can skip this step for now and complete the process later in your User Profile using an alternate browser or device.")
        }

        video[side] = false;

        self.setState({
            video: video
        });
    }

    generateCamIconAction(side) {
        if(this.state.confirm[side])
        {
            return (
                <a>
                    { CameraRetake("fill-transparent", "#C4CDD5") }
                </a>
            );
        }
        else if(this.state.capture[side])
        {
            return (
                <a onClick={() => this.startCamera(side)}>
                    { CameraRetake("fill-primary", "white") }
                </a>
            );
        }
        else if(this.state.video[side])
        {
            return (
                <a onClick={() => this.captureCamera(side)}>
                    { Camera("fill-primary", "white") }
                </a>
            );
        }
        else if((side == "front" && this.state.selectedProvince) || (side == "back" && this.state.confirm["front"]))
        {
            return (
                <a onClick={() => this.startCamera(side)}>
                    { Camera("fill-primary", "white") }
                </a>
            );
        }
        else 
        {
            return (
                <a onClick={() => this.startCamera(side)}>
                    { Camera("fill-transparent", "#C4CDD5") }
                </a>
            );
        }
    }
    
    render() {
        return (
            <div className = "validation-container">
                {
                    this.state.submiting_request ?
                        <LoadingIcon />
                    :
                        null
                }
                <div className="registration-navbar">
                    <img src="images/dvms_logo.png" />
                </div>
                <div className="registration-card validation-card">
                    <div className="registration-header">
                        <div className="registration-heading">
                            <Trans>Your Valid Driver's Licence</Trans>
                        </div>
                        <div className="validation-subheading">
                            <Trans>Confirming your Licence will help us to put the right drivers in our vehicles.</Trans>
                        </div>
                    </div>
                    <div className="registration-main">
                        <div className="validation-province">
                            <div className="validation-province-text"><Trans>Choose Your Province</Trans></div>
                            <div className="validation-province-selectbox">
                                <div className = "form-95">
                                    <Select 
                                        options={
                                            Object.keys(constants.provinces).map(function(province) {
                                                return(
                                                    {value: province, label: constants.provinces[province][0]}
                                                )
                                            })
                                        } 
                                        onChange={this.updateProvince}
                                        value={this.state.selectedProvince}
                                        style={{width: "100%", height:'36px'}}
                                        placeholder="Choose Issuing Province"
                                        className={"react_select_dropdown" + (this.state.error.province ? " validation-province-selectbox-error" : "")}
                                        classNamePrefix="react_select"
                                        isDisabled={!this.state.camera_support}
                                    />
                                    {
                                        this.state.error.province ?
                                            <div className="validation-province-selectbox-errormessage">
                                                <Trans>*A selection is required</Trans>
                                            </div>
                                        :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="validation-photo"> 
                        <div className="validation-photo-text"><Trans>Please take a photo of the front and back of your Driver's Licence using your camera.</Trans></div>
                        <div className="validation-photo-content">
                            <div className="validation-photo-nosupport" style={{"display": this.state.camera_support ? "none" : "block"}}>
                                <Trans>Your browser or device is not supported for this feature.</Trans>
                                <br /><br />
                                <Trans>You can skip this step for now and complete the process later in your User Profile using an alternate browser or device.</Trans>
                            </div>
                            <div className="validation-area validation-left">
                                <div className="validation-area-total-container">
                                    <div className={"validation-area-container" + (this.state.province_selected ? " active" : "") + (this.state.confirm.front ? " confirmed" : "")}>
                                        <div className="validation-area-text"><Trans>Front of ID</Trans></div>
                                        <div className="validation-area-picture">
                                            <video className="validation-video-container front" autoplay="" style={{"display": this.state.capture.front ? "none" : "block"}}></video>
                                            <img className="validation-photo-container front" style={{"display": this.state.capture.front ? "block" : "none"}} />
                                        </div>
                                        <div className="validation-area-button">
                                            { this.generateCamIconAction("front") }
                                        </div>
                                    </div>
                                    <div className={"validation-confirmation" + (this.state.capture.front ? " active" : "")}>
                                        <a onClick={() => this.confirmCamera("front")} className={"button see-through" + (this.state.confirm.front ? " confirmed" : "")}>
                                            <Trans>Confirm</Trans>
                                            <span className={"validation-confirmation-check" + (this.state.confirm.front ? " confirmed" : "")}>
                                                { CheckIcon("fill-green", "15px") }
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="validation-area">
                                <div className="validation-area-total-container">
                                    <div className={"validation-area-container" + (this.state.confirm.front ? " active" : "") + (this.state.confirm.back ? " confirmed" : "")}>
                                        <div className="validation-area-text"><Trans>Back of ID</Trans></div>
                                        <div className="validation-area-picture">
                                            <video className="validation-video-container back" autoplay="" style={{"display": this.state.capture.back ? "none" : "block"}}></video>
                                            <img className="validation-photo-container back" style={{"display": this.state.capture.back ? "block" : "none"}} />
                                        </div>
                                        <div className="validation-area-button">
                                            { this.generateCamIconAction("back") }
                                        </div>
                                    </div>
                                    <div className={"validation-confirmation" + (this.state.capture.back ? " active" : "")}>
                                        <a onClick={() => this.confirmCamera("back")} className={"button see-through" + (this.state.confirm.back ? " confirmed" : "")}>
                                            <Trans>Confirm</Trans>
                                            <span className={"validation-confirmation-check" + (this.state.confirm.back ? " confirmed" : "")}>
                                                { CheckIcon("fill-green", "15px") }
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="verification-information">
                                <img src="/images/icons/validation/Security.svg" className="verification-security" />
                                <span className="verification-securitytext"><Trans>Your information will be secured utilizing 256-bit encryption for sending, receiving, and storing your information.</Trans></span>
                            </div>
                        </div>
                    </div>
                    <div className="registration-actions">
                        <div className="registration-right">
                            <span className="grey" style={{cursor: "pointer"}} onClick={() => this.props.history.push('/mobilevalidation')}><Trans>Skip for now</Trans></span>
                            <span onClick={() => this.submitValidation()} className={"primary medium registration-button" + ((this.state.province_selected && this.state.confirm.front && this.state.confirm.back && !this.state.submiting_request) ? " registration-active" : "") + (this.state.submiting_request ? " disabled" : "")} style={{marginLeft: "20px"}}>
                                <span><Trans>Next</Trans></span>
                                <i className="fas fa-arrow-right" style={{marginLeft: "40px"}}></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
})

export default connect(mapStateToProps,)(IDVerification);